const prod = {
  ENVIRONMENT: "PROD",
  // SERVER_BASE_URL : "https://ijbsrphg08.execute-api.us-east-1.amazonaws.com/Prod/api/",
  SERVER_BASE_URL: "https://d7z22w3j4h.execute-api.us-east-1.amazonaws.com/Prod/api/",
  COMPANION_BASE_URL: "https://prod-companion-app-filemanagement.finerworks.com",
  WEBSOCKET_URL: ""
}

const dev = {
  ENVIRONMENT: "STAGE",
  // SERVER_BASE_URL : "https://ijbsrphg08.execute-api.us-east-1.amazonaws.com/Prod/api/",
  SERVER_BASE_URL: "https://d7z22w3j4h.execute-api.us-east-1.amazonaws.com/Prod/api/",
  COMPANION_BASE_URL: "https://companion-app-filemanagement.finerworks.com",
  WEBSOCKET_URL: ""
}

const prodDomain = ['prod1-filemanger-app.finerworks.com']
const isProd = prodDomain.includes(document.domain);

const config = isProd ? prod : dev;

export default {
  // Add common config values here
  MAX_CHARACTER_FILENAME: 30,
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};